import SEO from "../../../components/seo.jsx"
import { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HeroImg from "../../../assets/femaleHT-hero.png";
import BreadcrumbImg from "../../../assets/femaleHT-breadcrumb-bg.jpg";
import SurgeonImg from "../../../assets/team/dr-pranay.jpeg";
import CitiesImg from "../../../assets/shirdi-loc.png";

gsap.registerPlugin(ScrollTrigger);
const cinzel = { fontFamily: "'Cinzel', serif" };

/* ============================================================
   CONTENT pulled straight from the PHP "Female Hair Transplant in India" page
============================================================ */
const PAGE = {

  hero: {
    eyebrow: "For Women",
    heading: "Female Hair Transplant in India",
    sub: "Personalised, natural-looking hair restoration for women led by Dr. Pranay Thakur at Clinique Internationale.",
  },

  breadcrumb: [
    { label: "Home", href: "/" },
    { label: "Female Hair Transplant", href: null },
  ],

  intro: {
    eyebrow: "Overview",
    heading: "Female Hair Transplant in India",
    paragraphs: [
      "In India, the modern woman faces a growing struggle with hair loss due to busy schedules and mounting stress. This distressing trend has prompted clinics to implement cutting-edge techniques and treatments to counter female hair loss. Through personalised options such as PRP and laser therapy, India provides highly effective solutions that tackle women's hair loss concerns with diligence and skill.",
      "At Clinique Internationale, women can experience a truly transformative journey with our expert hair transplant services. Led by the renowned and highly experienced Dr. Pranay Thakur, our clinic is dedicated to providing exceptional care and precision. Dr. Gupta employs cutting-edge techniques for female hair restoration, such as FUE and PRP therapy, to achieve superb results that look natural. Our tailored solutions cater to the unique needs of each woman, helping them regain confidence and feel empowered in their appearance.",
    ],
  },

  surgeon: {
    eyebrow: "Lead Surgeon",
    heading: "Female Hair Transplant Surgeon in India",
    paragraphs: [
      "Dr. Pranay Thakur stands as a highly recommended hair transplant surgeon in India, offering over 18 years of exclusive expertise in this field. Renowned for his precision and commitment to excellence, Dr. Pranay Thakur specialises in female hair transplant procedures, addressing diverse hair loss concerns with adept skill.",
      "As a pioneer in the field, Dr. Pranay Thakur employs advanced techniques such as FUE and FUT, ensuring natural-looking results for women seeking hair restoration. His dedication extends beyond surgical expertise; he prioritises patient satisfaction and comfort throughout the process.",
      "Dr. Pranay Thakur reputation precedes him, drawing patients nationally and internationally seeking his exceptional services. With a track record of successful procedures and a compassionate approach, he stands as a beacon of trust and reliability in the realm of female hair transplant surgery in India.",
    ],
    stats: [
      { val: "18+ Yrs", sub: "Exclusive expertise" },
      { val: "FUE·FUT", sub: "Techniques offered" },
      { val: "National &", sub: "International patients" },
    ],
  },

  cost: {
    eyebrow: "Pricing",
    heading: "Female Hair Transplant Cost in India",
    intro:
      "The cost of a female hair transplant in India varies based on factors like clinic reputation, technique used, and the extent of treatment. At Clinique Internationale, on average, it ranges from ₹40,000 to ₹1,50,000 ($550 to $2,000) though figures can change depending on individual needs and the chosen clinic's expertise.",
    tableHeads: ["Level of Baldness", "Grafts Required", "Average Cost"],
    tableRows: [
      { level: "II", grafts: "1000 – 1500", cost: "₹30,000 – ₹40,000" },
      { level: "III", grafts: "1600 – 2100", cost: "₹35,000 – ₹45,000" },
      { level: "IV", grafts: "2300 – 3000", cost: "₹40,000 – ₹58,000" },
      { level: "V", grafts: "2600 – 3500", cost: "₹48,000 – ₹60,000" },
      { level: "VI", grafts: "3600 – 4200", cost: "₹70,000 – ₹1,00,000" },
      { level: "VII", grafts: "4500 – 5000", cost: "₹1,20,000 – ₹1,60,000" },
    ],
  },

  cities: {
    eyebrow: "Four Locations",
    heading: "Female Hair Transplant Across Three Major Cities",
    intro:
      "We extend female hair transplant services across Bangalore, Mumbai, Pune, and Shirdi in India spearheaded by experts who ensure top-notch care and personalised solutions for hair restoration.",
    items: [
      {
        num: "01",
        city: "Mumbai",
        doctor: "Dr Bhavesh Gupta",
        desc: "Experience the pinnacle of female hair transplant at Clinique Internationale's Mumbai centre led by Dr Bhavesh Gupta. With advanced techniques and a focus on natural-looking results, our centre stands as a premier destination for women seeking top-tier hair transplant in Mumbai.",
        href: "https://hairclinique.in/",
      },
      {
        num: "02",
        city: "Bangalore",
        doctor: "Dr. Idris",
        desc: "Discover the epitome of female hair transplant excellence at Clinique Internationale's Bangalore centre, led by the esteemed Dr. Idris. Renowned for his precision and dedication, he ensures top-notch care and optimal results for women seeking hair transplant solutions.",
        href: "https://bangalore.hairclinique.in/",
      },
      {
        num: "03",
        city: "Pune",
        doctor: "Dr. Ajinkya Patil",
        desc: "Indulge in the ultimate female hair transplant experience at Clinique Internationale's Pune location, under the leadership of the esteemed Dr. Ajinkya Patil, whose passion and proficiency guarantee unmatched service and remarkable outcomes.",
        href: "https://pune.hairclinique.in/",
      },
      {
        num: "04",
        city: "Shirdi",
        doctor: "Dr. Pranay Thakur",
        desc: "Indulge in the ultimate female hair transplant experience at Clinique Internationale's Shirdi location, under the leadership of the esteemed Dr. Pranay Thakur, whose passion and proficiency guarantee unmatched service and remarkable outcomes.",
        href: "/",
      },
    ],
  },

  procedure: {
    eyebrow: "Step by Step",
    heading: "Procedure of Female Hair Transplant in India",
    intro: "The procedure for female hair transplant at Clinique Internationale typically involves several steps:",
    steps: [
      { title: "Consultation", desc: "An initial consultation with a specialised surgeon assesses the extent of hair loss and discusses treatment options." },
      { title: "Pre-Operative Preparation", desc: "Pre-operative instructions are provided, and the surgical plan is customised based on the patient's needs." },
      { title: "Harvesting", desc: "Hair follicles are harvested through FUE or FUT from donor areas, usually at the back or sides of the scalp." },
      { title: "Graft Preparation", desc: "The harvested follicles are meticulously prepared under high-powered microscopes for transplantation." },
      { title: "Transplantation", desc: "The surgeon precisely implants the grafts into the recipient sites, considering the desired hairline and natural growth patterns." },
    ],
  },

  difference: {
    eyebrow: "Male vs. Female",
    heading: "Difference in Hair Transplant for Male and Female",
    intro:
      "Hair transplant procedures for men and women differ primarily in the pattern of hair loss and the approach to achieve natural-looking results:",
    items: [
      { title: "Pattern of Hair Loss", desc: "Men typically lose hair in a specific, usually stable pattern receding hairlines or bald spots. Female hair loss tends to be more diffuse, with a widening part or overall thinning." },
      { title: "Donor Area Suitability", desc: "Men usually have a stable donor area at the back and sides of the scalp. In women, the donor area might also suffer from thinning, making site selection more critical." },
      { title: "Hairline Design", desc: "Procedures for men often reconstruct the hairline for a masculine appearance. For women, the focus is a softer, more natural-looking hairline that complements facial features." },
      { title: "Graft Placement", desc: "Due to different hair loss patterns, distribution and placement of grafts vary. Women may require more careful planning for even distribution across thinning areas." },
      { title: "Expectations & Goals", desc: "Men often seek defined hairlines and thicker coverage, while women aim for natural density and volume without a masculine appearance." },
    ],
  },

  cta: {
    eyebrow: "Take the First Step",
    heading: "Begin Your Hair Restoration Journey",
    sub: "Book a personalised consultation with our team at Clinique Internationale and take the first step toward natural, lasting results.",
    primary: { label: "Book Consultation", href: "https://api.whatsapp.com/send?phone=919082123009&text=I%27m%20interested%20in%20Hair%20Restoration" },
    secondary: { label: "View All Treatments", href: "/about-hair-transplants.php" },
  },
};

/* ============================================================
   REUSABLE SUB-COMPONENTS
============================================================ */
function Eyebrow({ children, light = false, align = "left" }) {
  return (
    <p
      style={cinzel}
      className={`text-[10.5px] tracking-[0.28em] uppercase mb-3 flex items-center gap-2.5 ${
        align === "center" ? "justify-center" : "justify-start"
      } ${light ? "text-[#c9a84c]/70" : "text-[#a07828]"}`}
    >
      <span className={`w-6 h-px ${light ? "bg-[#c9a84c]/50" : "bg-[#c9a84c]"}`} />
      {children}
    </p>
  );
}

function SectionHeading({ children, light = false, align = "left" }) {
  return (
    <h2
      style={cinzel}
      className={`font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.85rem] uppercase tracking-[0.05em] mb-8 ${
        align === "center" ? "text-center" : "text-left"
      } ${light ? "text-white" : "text-[#1a0f02]"}`}
    >
      {children}
    </h2>
  );
}

function GoldDivider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent" />;
}

function FramedImage({ src, alt, className = "" }) {
  return (
    <div className={`relative rounded-2xl overflow-hidden border border-[#c9a84c]/25 ${className}`}>
      <img src={src} alt={alt} className="w-full h-full object-contain" />
      <span className="absolute inset-0 ring-1 ring-inset ring-[#c9a84c]/15 rounded-2xl pointer-events-none" />
    </div>
  );
}

/* ============================================================
   PAGE COMPONENT
============================================================ */
export default function FemaleHairTransplantShirdi({ url = "https://shirdi.hairclinique.in/female-hair-transplants.php" }) {
  const pageRef = useRef(null);
  const heroEyeRef = useRef(null);
  const heroHeadRef = useRef(null);
  const heroSubRef = useRef(null);
  const sectionRefs = useRef([]);
  const addSection = (el) => el && !sectionRefs.current.includes(el) && sectionRefs.current.push(el);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";
      gsap.fromTo(heroEyeRef.current, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease });
      gsap.fromTo(heroHeadRef.current, { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.75, ease, delay: 0.1 });
      gsap.fromTo(heroSubRef.current, { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.7, ease, delay: 0.18 });

      sectionRefs.current.forEach((el) => {
        if (!el) return;
        gsap.fromTo(
          el,
          { opacity: 0, y: 36 },
          {
            opacity: 1,
            y: 0,
            duration: 0.75,
            ease,
            scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" },
          }
        );
      });
    }, pageRef);
    return () => ctx.revert();
  }, []);

  /* full-bleed wrapper: fills the viewport with generous edge padding instead of a centered max-width column */
  const wrap = "w-full px-5 sm:px-10 lg:px-16 xl:px-24";
  const sec = "py-16 sm:py-20 md:py-24";

  return (
    <>
<SEO
  title="Female Hair Transplant in Shirdi | Clinique Internationale"
  description="Specialized female hair transplant treatments at Clinique Internationale, led by Dr Idris. Restore natural density with expert, tailored care."
  url={url}
/>
      <link
        href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap"
        rel="stylesheet"
      />

      <div
  ref={pageRef}
  className="relative w-full bg-[#f2ece0] overflow-hidden mt-16 lg:mt-20"
  style={{ fontFamily: "'Raleway', sans-serif" }}
>
  {/* ══════════════════════════════════════
      HERO full width
  ══════════════════════════════════════ */}
  <div className="relative w-full h-[200px] xs:h-[280px] sm:h-[340px] md:h-[700px] flex items-center justify-end overflow-hidden">
    <img className="absolute inset-0 w-full h-full object-cover object-[center_20%] md:object-center" src={HeroImg} alt={PAGE.hero.heading} />
    <div className="absolute inset-0" />
    <div
      className="absolute inset-0 opacity-40 pointer-events-none"
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E\")",
      }}
    />
    <div className="relative z-10 text-right px-4 sm:px-10 md:px-16 max-w-[85%] sm:max-w-xl ml-auto mr-0">
      <p ref={heroEyeRef} style={cinzel} className="text-[8px] xs:text-[9px] sm:text-[10.5px] tracking-[0.2em] xs:tracking-[0.24em] sm:tracking-[0.32em] uppercase text-[#000000] mb-2 sm:mb-4 flex items-center justify-end gap-2 sm:gap-3">
        <span className="w-4 sm:w-7 h-px bg-[#c9a84c]" />
        {PAGE.hero.eyebrow}
        <span className="w-4 sm:w-7 h-px bg-[#c9a84c]" />
      </p>
      <h1
        ref={heroHeadRef}
        style={cinzel}
        className="font-black text-[0.5rem] xs:text-[1.8rem] sm:text-[2.8rem] md:text-[3.4rem] tracking-[0.02em] sm:tracking-[0.04em] uppercase text-black mb-2 sm:mb-3 leading-[1.15] sm:leading-tight"
      >
        {PAGE.hero.heading}
      </h1>
      <p ref={heroSubRef} className="text-[11px] xs:text-[12px] sm:text-[15px] text-black/70 leading-relaxed ml-auto">
        {PAGE.hero.sub}
      </p>
    </div>
  </div>

        {/* ── BREADCRUMB full width with background image ── */}
        <div className="relative w-full overflow-hidden">
          <img className="absolute inset-0 w-full h-full object-cover" src={BreadcrumbImg} alt="" aria-hidden="true" />
          <div className="absolute inset-0 bg-[#0e0905]/88" />
          <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/25 to-transparent" />
          <div className={`relative ${wrap} py-3.5 flex flex-wrap items-center gap-2`}>
            {PAGE.breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-[#c9a84c]/30 text-xs">›</span>}
                {b.href ? (
                  <a href={b.href} style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]/60 hover:text-[#c9a84c] transition-colors">
                    {b.label}
                  </a>
                ) : (
                  <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]">
                    {b.label}
                  </span>
                )}
              </span>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════
            INTRO
        ══════════════════════════════════════ */}
<div className={`${wrap} ${sec}`}>
  <div ref={addSection} className="max-w-2xl mx-auto text-center">
    <Eyebrow>{PAGE.intro.eyebrow}</Eyebrow>
    <SectionHeading>{PAGE.intro.heading}</SectionHeading>
    {PAGE.intro.paragraphs.map((p, i) => (
      <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] mb-4">
        {p}
      </p>
    ))}
  </div>
</div>

        {/* ══════════════════════════════════════
            SURGEON (dark band, image + stats)
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection} className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
              <div>
                <Eyebrow light>{PAGE.surgeon.eyebrow}</Eyebrow>
                <SectionHeading light>{PAGE.surgeon.heading}</SectionHeading>
                {PAGE.surgeon.paragraphs.map((p, i) => (
                  <p key={i} className="text-[13.5px] leading-[1.9] text-white/60 mb-4">
                    {p}
                  </p>
                ))}
              </div>
              <div className="flex flex-col gap-5">
                <FramedImage src={SurgeonImg} alt="Dr Idris, female hair transplant surgeon" className="h-[260px] sm:h-[320px]" />
                <div className="grid grid-cols-3 gap-4">
                  {PAGE.surgeon.stats.map((s, i) => (
                    <div
                      key={i}
                      className="bg-white/[0.04] border border-[#c9a84c]/12 rounded-xl p-4 text-center hover:bg-[#c9a84c]/[0.07] hover:border-[#c9a84c]/25 transition-colors"
                    >
                      <div style={cinzel} className="font-black text-[1.1rem] leading-none mb-1 bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">
                        {s.val}
                      </div>
                      <div className="text-[10px] text-white/45 leading-snug">{s.sub}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            COST TABLE
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow align="center">{PAGE.cost.eyebrow}</Eyebrow>
            <SectionHeading align="center">{PAGE.cost.heading}</SectionHeading>
            <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-8">{PAGE.cost.intro}</p>

            <div className="overflow-x-auto rounded-2xl border border-[#c9a84c]/20 shadow-[0_4px_24px_rgba(90,60,10,0.07)] max-w-3xl mx-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[#0e0905]">
                    {PAGE.cost.tableHeads.map((h) => (
                      <th key={h} style={cinzel} className="text-left text-[11px] tracking-[0.1em] uppercase text-[#c9a84c] px-5 py-4 font-bold">
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {PAGE.cost.tableRows.map((r, i) => (
                    <tr key={i} className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white" : "bg-[#f2ece0]"} hover:bg-[#c9a84c]/[0.05] transition-colors`}>
                      <td className="px-5 py-4">
                        <span style={cinzel} className="text-[12px] font-bold text-[#a07828] tracking-wide">
                          Grade {r.level}
                        </span>
                      </td>
                      <td className="px-5 py-4 text-[13px] font-semibold text-[#1a0f02]">{r.grafts}</td>
                      <td className="px-5 py-4 text-[13px] font-semibold text-[#1a0f02]">{r.cost}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            THREE CITIES (image + list)
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow align="center">{PAGE.cities.eyebrow}</Eyebrow>
              <SectionHeading align="center">{PAGE.cities.heading}</SectionHeading>
              <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">{PAGE.cities.intro}</p>

              <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.1fr] gap-10 items-start">
                <FramedImage src={CitiesImg} alt="Clinique Internationale facility" className="h-[260px] sm:h-[340px] lg:h-full lg:sticky lg:top-24" />
                <div className="flex flex-col gap-5">
                  {PAGE.cities.items.map((c) => (
                    <div key={c.num} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:shadow-[0_8px_28px_rgba(90,60,10,0.08)] transition-shadow">
                      <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                      <div className="flex gap-5 items-start">
                        <span style={cinzel} className="font-black text-[2rem] leading-none text-[#c9a84c]/20 select-none flex-shrink-0">
                          {c.num}
                        </span>
                        <div>
                          <div style={cinzel} className="text-[13px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] mb-0.5">
                            {c.city}
                          </div>
                          <p className="text-[11px] tracking-[0.08em] uppercase text-[#a07828] mb-2.5">{c.doctor}</p>
                          <p className="text-[13px] leading-[1.8] text-[#6b5535]">{c.desc}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            PROCEDURE STEPS (dark band)
        ══════════════════════════════════════ */}
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow light align="center">{PAGE.procedure.eyebrow}</Eyebrow>
              <SectionHeading light align="center">{PAGE.procedure.heading}</SectionHeading>
              <p className="text-[13.5px] leading-[1.9] text-white/60 max-w-3xl mx-auto text-center mb-10">{PAGE.procedure.intro}</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-5">
                {PAGE.procedure.steps.map((s, i) => (
                  <div
                    key={i}
                    className="relative overflow-hidden bg-gradient-to-br from-[#c9a84c]/[0.07] to-[#c9a84c]/[0.02] border border-[#c9a84c]/15 rounded-2xl p-6 hover:border-[#c9a84c]/30 transition-colors"
                  >
                    <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/35 to-transparent" />
                    <span style={cinzel} className="font-black text-[1.6rem] leading-none text-[#c9a84c]/25 select-none block mb-3">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div style={cinzel} className="text-[12px] font-bold tracking-[0.05em] uppercase text-white/90 mb-2">
                      {s.title}
                    </div>
                    <p className="text-[12.5px] leading-[1.75] text-white/55">{s.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            MALE VS FEMALE DIFFERENCES
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow align="center">{PAGE.difference.eyebrow}</Eyebrow>
            <SectionHeading align="center">{PAGE.difference.heading}</SectionHeading>
            <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">{PAGE.difference.intro}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {PAGE.difference.items.map((d, i) => (
                <div
                  key={i}
                  className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300"
                >
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/10 to-[#c9a84c]/[0.03] border border-[#c9a84c]/20 flex items-center justify-center mb-4">
                    <span style={cinzel} className="text-[12px] font-black text-[#c9a84c]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.06em] uppercase text-[#1a0f02] mb-2">
                    {d.title}
                  </div>
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{d.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            CTA
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={`${wrap} max-w-xl mx-auto text-center`}>
            <div ref={addSection}>
              <Eyebrow align="center">{PAGE.cta.eyebrow}</Eyebrow>
              <h3
                style={cinzel}
                className="font-black text-[1.3rem] sm:text-[1.65rem] md:text-[1.9rem] text-[#1a0f02] uppercase tracking-[0.06em] mb-3.5"
              >
                {PAGE.cta.heading}
              </h3>
              <p className="text-[14px] text-[#6b5535] leading-[1.75] mb-8">{PAGE.cta.sub}</p>
              <div className="flex items-center justify-center gap-4 flex-wrap">
                <a
                  href={PAGE.cta.primary.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }}
                  className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-md text-[#1a0f02] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] transition-all inline-block"
                >
                  {PAGE.cta.primary.label}
                </a>
                <a
                  href={PAGE.cta.secondary.href}
                  style={cinzel}
                  className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-[13px] rounded-md bg-transparent border border-[#1a0f02]/35 text-[#1a0f02] hover:-translate-y-0.5 hover:border-[#c9a84c] hover:text-[#a07828] transition-all inline-block"
                >
                  {PAGE.cta.secondary.label}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
